export const QUOTE_PAYMENT_PLAN_MONTH_PERIODS = [
    { name: 'Dia 1 a 15', code: 1 },
    { name: 'Dia 16 a 31', code: 2 }
];

export const QUOTE_PAYMENT_START_MONTH = [
    { name: 'Mês atual', code: 1 },
    { name: 'Mês seguinte', code: 2 }
];

export const QUOTE_PAYMENT_PLAN_NOTIFIED = 1;
export const QUOTE_PAYMENT_PLAN_ACTIVE = 2;
export const QUOTE_PAYMENT_PLAN_PART_PAYED = 2;